import type { App } from "vue";
import type { DemandeDTO } from '@/features/api/extranet/dto/Demande/shared'
import { naturesFichiersAf } from '@/features/domaine/regles-akto/AF'
import { naturesFichiersCapp } from '@/features/domaine/regles-akto/CAPP'
import { naturesFichiersCpro } from '@/features/domaine/regles-akto/CPRO'
import { naturesFichiersProa } from '@/features/domaine/regles-akto/PROA'
import { type NaturesFichierProvider } from '@/features/domaine/types/opco'

// Todo : Injecter dépendances globale App ici
export default {
  install(app: App<Element>) {
    // Natures fichier
    app.provide<NaturesFichierProvider<DemandeDTO>>(naturesFichiersCapp.key, naturesFichiersCapp)
    app.provide<NaturesFichierProvider<DemandeDTO>>(naturesFichiersAf.key, naturesFichiersAf)
    app.provide<NaturesFichierProvider<DemandeDTO>>(naturesFichiersCpro.key, naturesFichiersCpro)
    app.provide<NaturesFichierProvider<DemandeDTO>>(naturesFichiersProa.key, naturesFichiersProa)
  }
}